/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type RioVehicleTelemetryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input']
}>

export type RioVehicleTelemetryQuery = {
  __typename?: 'Query'
  vehicleByID: {
    __typename?: 'Vehicle'
    id: string
    latestADTelemetry: {
      __typename?: 'ADTelemetry'
      sdsConnectivityState: {
        __typename?: 'ADConnectivityStateWithTimestamp'
        connectivityState: Types.AdConnectivityState
        timestamp: string
      } | null
      signalConnectivityState: {
        __typename?: 'ADConnectivityStateWithTimestamp'
        connectivityState: Types.AdConnectivityState
        timestamp: string
      } | null
      cabinConnectivityState: {
        __typename?: 'ADConnectivityStateWithTimestamp'
        connectivityState: Types.AdConnectivityState
        timestamp: string
      } | null
      highVoltBatterySOCPercentage: {
        __typename?: 'ADTelemetryFloatWithTimestamp'
        value: number
        timestamp: string
      } | null
    } | null
  }
}

export const RioVehicleTelemetryDocument = gql`
    query RioVehicleTelemetry($id: ID!) {
  vehicleByID(id: $id) {
    id
    latestADTelemetry {
      sdsConnectivityState {
        connectivityState
        timestamp
      }
      signalConnectivityState {
        connectivityState
        timestamp
      }
      cabinConnectivityState {
        connectivityState
        timestamp
      }
      highVoltBatterySOCPercentage {
        value
        timestamp
      }
    }
  }
}
    `

/**
 * __useRioVehicleTelemetryQuery__
 *
 * To run a query within a React component, call `useRioVehicleTelemetryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRioVehicleTelemetryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRioVehicleTelemetryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRioVehicleTelemetryQuery(
  baseOptions: Apollo.QueryHookOptions<
    RioVehicleTelemetryQuery,
    RioVehicleTelemetryQueryVariables
  > &
    (
      | { variables: RioVehicleTelemetryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RioVehicleTelemetryQuery,
    RioVehicleTelemetryQueryVariables
  >(RioVehicleTelemetryDocument, options)
}
export function useRioVehicleTelemetryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RioVehicleTelemetryQuery,
    RioVehicleTelemetryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RioVehicleTelemetryQuery,
    RioVehicleTelemetryQueryVariables
  >(RioVehicleTelemetryDocument, options)
}
// @ts-ignore
export function useRioVehicleTelemetrySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RioVehicleTelemetryQuery,
    RioVehicleTelemetryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RioVehicleTelemetryQuery,
  RioVehicleTelemetryQueryVariables
>
export function useRioVehicleTelemetrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RioVehicleTelemetryQuery,
        RioVehicleTelemetryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RioVehicleTelemetryQuery | undefined,
  RioVehicleTelemetryQueryVariables
>
export function useRioVehicleTelemetrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RioVehicleTelemetryQuery,
        RioVehicleTelemetryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RioVehicleTelemetryQuery,
    RioVehicleTelemetryQueryVariables
  >(RioVehicleTelemetryDocument, options)
}
export type RioVehicleTelemetryQueryHookResult = ReturnType<
  typeof useRioVehicleTelemetryQuery
>
export type RioVehicleTelemetryLazyQueryHookResult = ReturnType<
  typeof useRioVehicleTelemetryLazyQuery
>
export type RioVehicleTelemetrySuspenseQueryHookResult = ReturnType<
  typeof useRioVehicleTelemetrySuspenseQuery
>
export type RioVehicleTelemetryQueryResult = Apollo.QueryResult<
  RioVehicleTelemetryQuery,
  RioVehicleTelemetryQueryVariables
>
